import { usePropertyContactName } from '../../../../../queries/PropertyFields/NonRentalContactFields';
import { TextBox } from '@apply/components';
import { ApplicationPropertyFieldLength } from '@apply/constants';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface OnsitePropertyContactNameProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const OnsitePropertyContactName: React.FC<OnsitePropertyContactNameProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Name';
    const [onsitePropertyContactName, set_onsitePropertyContactName] = usePropertyContactName(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={`Contact ${label}`}
                    value={onsitePropertyContactName}
                />
            ) : (
                <TextBox
                    id='onsitePropertyContactName'
                    value={onsitePropertyContactName}
                    onChange={(value) => set_onsitePropertyContactName(value)}
                    label={label}
                    placeholder='John Smith'
                    required={required}
                    width='100%'
                    maxLength={ApplicationPropertyFieldLength.contactName}
                />
            )}
        </>
    );
};
